export default {
  today: 'Oggi',
  tomorrow: 'Domani',
};
